module.exports = __webpack_public_path__ + "img/ctrl-p-stub-down--.b766b0f9.svg";